<div class="px-3 container">
    <a class="{{hidden ? 'd-none' : ''}}" (click)="click"> 
        <img alt="nextPim Pim System" [src]="logoUrl" class="image" />
    </a>   
</div>